import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/auth-context';

const Logout = ({ className }) => {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    return (
        <div className={className}>
            <button
                className="w-full h-10 flex items-center justify-between px-3 py-2 bg-white/10 text-white border border-white/20 rounded-md text-sm hover:bg-white/20 transition"
                onClick={() => {
                    auth.logout();
                    navigate("/admin/login");
                }}
            >
                Logout
            </button>
        </div>
    )
}

export default Logout